import numeral from 'numeral';
import HomeStatusFilter from './filters/homes/Status';

const config = {
  builder_id: '5bbe04af4db0487e651fffe8',
  auth_domain: 'woodbridgecommunities.com',
  entity_logos: {
    plan: 'elevationPhotos[0]',
    community: 'logo',
    home: 'photos[0]',
  },
  mapbox: {
    key: 'pk.eyJ1IjoiYnVpbGRlcmRlc2lnbnMiLCJhIjoiY2ptMHB6dGU3MDg5YjN3bzYzYjJoOXdudyJ9.JuWCUohIoikKAmpp6904Fw',
  },
  social_links: {
    facebook: '/images/icon-facebook.svg',
    instagram: '/images/icon-instagram.svg',
    youtube: '/images/icon-youtube.svg',
    pinterest: '/images/icon-pinterest.svg',
    twitter: '/images/icon-twitter.svg',
    houzz: '/images/icon-houzz.svg',
    linkedin: '/images/icon-linkedin.svg',
    googleplus: '/images/icon-google-plus.svg',
    fallback: '/images/icon-baths.svg',
  },
  filters: {
    all: {
      Area: {
        routeParam: 'communityMarketArea',
      },
      Price: {
        labelRender: ({ value }) => `${numeral(value.start).format('$0,0')} - ${numeral(value.end).format('$0,0')}`,
      },
    },
    homes: {
      Status: HomeStatusFilter,
    },
  },
};

export default config;



// WEBPACK FOOTER //
// ./src/configuration.js